import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import Comment from './Comment'
import PreviousReviewsList from './PreviousReviewsList'
import MarkdownLabel from '../../../mini/MarkdownLabel'
import ModalComponent from '../../../mini/ModalComponent'
import UserName from '../../../mini/UserName'

import { setQuestSection } from '../../../../actions/quest'
import {
  createCompiledQuestReview,
  deleteCompiledQuestReview,
  approveReviewCriterion,
  rejectReviewCriterion,
  nullifyReviewCriterionApproval,
  completeCompiledQuestReview,
  editReviewComment,
  revertQuestToDraft
} from '../../../../actions/review'
import {
  isInternalReviewer,
  isOeReviewer,
  isQuestCopyEditorOrQuestAuthor
} from '../../../../utils/user'
import {
  getTotalReviewState,
  findReview,
  findRejectedReview,
  getFilteredReviews,
  getCompletedReviewInfo,
  getReviewApprovalStatus,
  checkPreviousReviewsNoCurrent,
  isActiveWithThisReviewer,
  translateReviewState,
  getIntlReviewTypeWithContext,
  questIsInQualityReview
} from '../../../../utils/review'
import { beginReview, approved, needsEdits } from '../../../../utils/messages'
import {
  headingMessages,
  bodyMessages,
  buttonMessages
} from '../../../../utils/messages/modal'
import { currentReviewsFilteredForQuestState } from '../../../../selectors/review'

class ReviewArea extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing:
        this.isThisReviewActive(props.activeReview) &&
        isActiveWithThisReviewer(props.activeReview, props.user)
    }
    this.hideModalBound = this.hideModal.bind(this)
    this.onBeginReviewClickBound = this.onBeginReviewClick.bind(this)
    this.onCancelClickBound = this.onCancelClick.bind(this)
    this.onActualCancelClickBound = this.onActualCancelClick.bind(this)
    this.onApproveClickBound = this.onApproveClick.bind(this)
    this.onRejectClickBound = this.onRejectClick.bind(this)
    this.onEditApprovalClickBound = this.onEditApprovalClick.bind(this)
    this.onCompleteReviewClickBound = this.onCompleteReviewClick.bind(this)
    this.onActualCompleteReviewClickBound =
      this.onActualCompleteReviewClick.bind(this)
    this.onRevertToDraftClickBound = this.onRevertToDraftClick.bind(this)
  }

  componentDidMount() {
    this.cancelReviewModal = this.refs.cancelReviewModal.refs.modal
    this.someOeApprovedModal = this.refs.someOeApprovedModal.refs.modal
    this.readyForPublishModal = this.refs.readyForPublishModal.refs.modal
    this.someReviewRejectedModal = this.refs.someReviewRejectedModal.refs.modal
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isEditing:
        this.isThisReviewActive(nextProps.activeReview) &&
        isActiveWithThisReviewer(nextProps.activeReview, nextProps.user)
    })
  }

  render() {
    const {
      reviewType,
      activeReview,
      quest,
      user,
      currentReviews,
      previousReviews,
      intlReviewType
    } = this.props
    const { intl } = this.context
    const review = findReview(currentReviews, reviewType)
    const reviewAuthor = review ? review.reviewer.name : ''
    const reviewer = review ? review.reviewer : ''
    const rejectedReview = findRejectedReview(currentReviews)
    const filteredReviews = getFilteredReviews(previousReviews, reviewType)
    const reviewTypeWithContextInSentence = getIntlReviewTypeWithContext(
      reviewType,
      intl,
      'sentence'
    )

    const modalMessages = {
      header: {
        cancelReview: intl.formatMessage(headingMessages.cancelReview),
        almostDone: intl.formatMessage(headingMessages.almostDone),
        returningToQuestDesigner: intl.formatMessage(
          headingMessages.returningToQuestDesigner
        ),
        readyForPublish: intl.formatMessage(headingMessages.readyForPublish)
      },
      body: {
        ifYouCancel: intl.formatMessage(bodyMessages.ifYouCancel),
        thanksForYourReviewOE: intl.formatMessage(
          bodyMessages.thanksForYourReviewOE
        ),
        questNeedsEdits: intl.formatMessage(bodyMessages.questNeedsEdits),
        passedAllReviews1: intl.formatMessage(bodyMessages.passedAllReviews1),
        passedAllReviews2: intl.formatMessage(bodyMessages.passedAllReviews2),
        passedAllReviews3: intl.formatMessage(bodyMessages.passedAllReviews3)
      },
      button: {
        cancel: intl.formatMessage(buttonMessages.cancel),
        ok: intl.formatMessage(buttonMessages.ok),
        yes: intl.formatMessage(buttonMessages.yes),
        no: intl.formatMessage(buttonMessages.no),
        publish: intl.formatMessage(buttonMessages.publish)
      }
    }

    const noReviewMessagesOe =
      'This quest has not received {reviewType} review yet.'
    const rejectedClass =
      !activeReview &&
      rejectedReview === reviewType &&
      quest.reviewing_compiled_quest
        ? 'rejected'
        : ''

    return (
      <div className={`review-area ${rejectedClass}`}>
        <div className="review-area-anchor" id={`section-${reviewType}`}>
          &nbsp;
        </div>
        <div className={this.getHeaderStyles(review)}>{intlReviewType}</div>
        {/* <div className='review-header'>{intlReviewType}</div> */}
        {this.state.isEditing &&
          quest.current_compiled_quest.state !== 'recalled' && (
            <div>
              {activeReview && activeReview.accepted === null ? (
                <div>
                  <div
                    className="review-action approve"
                    title="Approve"
                    onClick={this.onApproveClickBound}
                  ></div>
                  <div
                    className="review-action reject"
                    title="Reject"
                    onClick={this.onRejectClickBound}
                  ></div>
                </div>
              ) : (
                <div className="approval-status-container">
                  <div className="approval-rejection">
                    {review &&
                      (review.accepted === true ? approved : needsEdits)}
                  </div>
                  <div
                    className="edit"
                    onClick={this.onEditApprovalClickBound}
                  ></div>
                </div>
              )}
              <Comment
                isEditing={this.state.isEditing}
                review={review}
                quest={this.props.quest}
                handleComplete={this.onCompleteReviewClickBound}
                handleCancel={this.onCancelClickBound}
              />
            </div>
          )}
        {this.showUnstartedReviewUi(review) && (
          <div>
            {this.showOeReviewAreaNotStartedMessage(
              review,
              filteredReviews
            ) && (
              <div className="review-body">
                <FormattedMessage
                  id={'Quest.Review.ReviewArea.ThisQuestHasNotReceived'}
                  defaultMessage={noReviewMessagesOe}
                  values={{
                    reviewType: reviewTypeWithContextInSentence.toLowerCase()
                  }}
                />
              </div>
            )}
            {isOeReviewer(user) && questIsInQualityReview(quest) && (
              <div
                className={
                  this.isSomeOtherReviewActive() ? 'disabled button' : 'button'
                }
                onClick={this.onBeginReviewClickBound}
              >
                {beginReview}
              </div>
            )}
          </div>
        )}
        {this.showCompletedReviewUi(review) && (
          <div className="completed-review">
            <div className="approval-rejection-info">
              <strong>{getCompletedReviewInfo(review)}</strong>
              &nbsp;&nbsp;
              <OEComponents.DateFormatter
                date={review.completed_at}
                includeTime={false}
              />
              {' at '}
              <OEComponents.Time time={review.completed_at} />
            </div>
            <div className="completed-review-comment-wrapper">
              {review && review.comment && review.comment.length > 0 && (
                <div>
                  <div className="completed-review-comment">
                    <MarkdownLabel
                      additionalCssClasses="completed-review-comment"
                      value={review.comment}
                    />
                  </div>
                  <div className="reviewer-info-container">
                    <div className="user-photo-wrapper">
                      <img src={reviewer.photo_url} />
                    </div>
                    <UserName
                      activeCertifications={reviewer.active_certifications}
                      userId={`current-review-${reviewType}-${reviewer.id}`}
                      rebuild
                    >
                      <div className="reviewer-name">
                        {reviewer.display_name || reviewer.name}
                      </div>
                    </UserName>
                  </div>
                </div>
              )}
              {review && (!review.comment || review.comment.length === 0) && (
                <div className="no-review-comment">
                  <div className="user-photo-wrapper">
                    <img src={reviewer.photo_url} />
                  </div>
                  <UserName
                    activeCertifications={reviewer.active_certifications}
                    userId={`current-review-${reviewType}-${reviewer.id}`}
                    rebuild
                  >
                    <div className="reviewer-name">
                      {reviewer.display_name || reviewer.name}
                    </div>
                  </UserName>
                </div>
              )}
            </div>
            {this.showEditRejectedQuestButton(review) && (
              <div
                className="button revert-to-draft"
                onClick={this.onRevertToDraftClickBound}
              >
                <FormattedMessage
                  id={'Quest.Review.ReviewArea.OKBegin'}
                  defaultMessage={'OK, Edit this Quest'}
                />
              </div>
            )}
          </div>
        )}
        {(this.showWasActiveWithThisReviewerUi(review) ||
          this.showActiveWithAnotherReviewerUi(review)) && (
          <div className="active-with-another-reviewer">
            {`${reviewAuthor} began this review on `}
            <OEComponents.DateFormatter
              date={review.created_at}
              includeTime={false}
            />
            {' at '}
            <OEComponents.Time time={review.created_at} />.
          </div>
        )}
        {/* TODO: Clean up this mess */}
        {filteredReviews.length > 0 && (
          <PreviousReviewsList
            reviews={filteredReviews}
            previousReviewsNoCurrent={
              checkPreviousReviewsNoCurrent(filteredReviews, review) &&
              (!quest.reviewing_compiled_quest ||
                (quest.reviewing_compiled_quest &&
                  (!questIsInQualityReview(quest) ||
                    (quest.reviewing_compiled_quest.state === 'submitted' &&
                      !isInternalReviewer(user)))))
            }
            reviewType={reviewType}
          />
        )}
        <ModalComponent
          ref="cancelReviewModal"
          quest={quest}
          klass="review-modal modal"
          modalId="cancelReviewModal"
          headingKlass="modal-heading alert"
          logoKlass="logo alert"
          headingText={modalMessages.header.cancelReview}
          bodyText={modalMessages.body.ifYouCancel}
          primaryButtonText={modalMessages.button.yes}
          secondaryButtonText={modalMessages.button.no}
          primaryButtonAction={this.onActualCancelClickBound}
          secondaryButtonAction={this.hideModalBound}
        />
        <ModalComponent
          ref="someOeApprovedModal"
          quest={quest}
          klass="review-modal modal"
          modalId="someOeApprovedModal"
          headingKlass="modal-heading"
          logoKlass="logo"
          headingText={modalMessages.header.almostDone}
          bodyText={modalMessages.body.thanksForYourReviewOE}
          primaryButtonText={modalMessages.button.yes}
          secondaryButtonText={modalMessages.button.cancel}
          primaryButtonAction={this.onActualCompleteReviewClickBound}
          secondaryButtonAction={this.hideModalBound}
          questLogo
        />
        <ModalComponent
          ref="someReviewRejectedModal"
          quest={quest}
          klass="review-modal modal"
          modalId="someReviewRejectedModal"
          headingKlass="modal-heading"
          logoKlass="logo reject"
          headingText={modalMessages.header.returningToQuestDesigner}
          bodyText={modalMessages.body.questNeedsEdits}
          primaryButtonText={modalMessages.button.ok}
          secondaryButtonText={modalMessages.button.cancel}
          primaryButtonAction={this.onActualCompleteReviewClickBound}
          secondaryButtonAction={this.hideModalBound}
        />
        <ModalComponent
          ref="readyForPublishModal"
          quest={quest}
          klass="review-modal modal"
          modalId="readyForPublishModal"
          headingKlass="modal-heading success"
          logoKlass="logo"
          headingText={modalMessages.header.readyForPublish}
          bodyText={[
            modalMessages.body.passedAllReviews1,
            <strong>&nbsp;{modalMessages.body.passedAllReviews2}&nbsp;</strong>,
            modalMessages.body.passedAllReviews3
          ]}
          primaryButtonText={modalMessages.button.publish}
          secondaryButtonText={modalMessages.button.cancel}
          primaryButtonAction={this.onActualCompleteReviewClickBound}
          secondaryButtonAction={this.hideModalBound}
          questLogo
        />
      </div>
    )
  }

  showActiveWithAnotherReviewerUi(review) {
    const { activeReview, user } = this.props
    return (
      this.isThisReviewActive(activeReview) &&
      !isActiveWithThisReviewer(activeReview, user) &&
      review &&
      !review.completed_at
    )
  }

  showWasActiveWithThisReviewerUi(review) {
    const { activeReview, user, quest } = this.props
    return (
      this.isThisReviewActive(activeReview) &&
      isActiveWithThisReviewer(activeReview, user) &&
      review &&
      !review.completed_at &&
      quest.current_compiled_quest.state === 'recalled'
    )
  }

  showEditRejectedQuestButton(review) {
    const { user, quest, organization } = this.props
    return (
      isQuestCopyEditorOrQuestAuthor(user, quest, organization) &&
      review.accepted === false &&
      quest.current_compiled_quest.state === 'rejected' &&
      quest.reviewing_compiled_quest
    )
  }

  showCompletedReviewUi(review) {
    return !this.state.isEditing && review && review.completed_at
  }

  showUnstartedReviewUi(review) {
    return (
      !this.state.isEditing &&
      this.reviewNotStartedNorCompleted(review) &&
      !this.isActiveWithAnotherReviewer(this.props.activeReview)
    )
  }

  showOeReviewAreaNotStartedMessage(review, filteredReviews) {
    const { quest } = this.props
    return (
      (!review &&
        (filteredReviews.length === 0 ||
          (quest.reviewing_compiled_quest &&
            (quest.reviewing_compiled_quest.state === 'platform_review' ||
              quest.reviewing_compiled_quest.state === 'submitted')))) ||
      (Boolean(quest.current_compiled_quest) &&
        quest.current_compiled_quest.state === 'recalled')
    )
  }

  getHeaderStyles(review) {
    var cssClass = 'review-header '
    if (review && !review.completed) {
      cssClass += getReviewApprovalStatus(review)
    }
    return cssClass
  }

  reviewNotStartedNorCompleted(review) {
    return !review || (review && !review.completed_at)
  }

  isSomeOtherReviewActive() {
    return (
      this.props.activeReview &&
      this.props.reviewType !== this.props.activeReview.criteria
    )
  }

  isThisReviewActive(activeReview) {
    return activeReview && this.props.reviewType === activeReview.criteria
  }

  isActiveWithAnotherReviewer(activeReview) {
    return (
      this.isThisReviewActive(activeReview) &&
      !isActiveWithThisReviewer(activeReview, this.props.user)
    )
  }

  onBeginReviewClick() {
    // setQuestSection is necessary because if a subsection is stored in state, the user will
    // be scrolled to it (example is when coming to Quest detail from the review queue - user may select "Experience"
    // and then decide they want to review "Copy" instead and when they select "Begin Review" they'd be scrolled
    // back to "Experience" - this fixes that issue.
    this.props.dispatch(
      setQuestSection('questreview', null, this.props.reviewType)
    )

    this.props.dispatch(
      createCompiledQuestReview(
        this.props.quest.id,
        this.props.quest.reviewing_compiled_quest.id,
        this.props.reviewType
      )
    )
    this.setState({
      isEditing: true
    })
  }

  onCancelClick() {
    this.cancelReviewModal.show()
  }

  onActualCancelClick() {
    const { quest, activeReview } = this.props
    this.props.dispatch(
      deleteCompiledQuestReview(
        quest.id,
        quest.reviewing_compiled_quest.id,
        activeReview.id
      )
    )
    this.setState({
      isEditing: false
    })
    this.cancelReviewModal.hide()
  }

  onApproveClick() {
    const { quest, activeReview } = this.props
    this.props.dispatch(
      approveReviewCriterion(
        quest.id,
        quest.reviewing_compiled_quest.id,
        activeReview.id
      )
    )
  }

  onRejectClick() {
    const { quest, activeReview } = this.props
    this.props.dispatch(
      rejectReviewCriterion(
        quest.id,
        quest.reviewing_compiled_quest.id,
        activeReview.id
      )
    )
  }

  onEditApprovalClick() {
    const { quest, activeReview } = this.props
    this.props.dispatch(
      nullifyReviewCriterionApproval(
        quest.id,
        quest.reviewing_compiled_quest.id,
        activeReview.id
      )
    )
  }

  onCompleteReviewClick(comment) {
    const { dispatch, currentReviews, quest, reviewType } = this.props
    const review = findReview(currentReviews, reviewType)
    if (comment) {
      dispatch(
        editReviewComment(
          quest.id,
          quest.reviewing_compiled_quest.id,
          review.id,
          comment
        )
      )
    }

    let totalReviewState = getTotalReviewState(currentReviews)
    switch (totalReviewState) {
      case 'someOeApproved':
        this.someOeApprovedModal.show()
        break
      case 'readyForPublish':
        this.readyForPublishModal.show()
        break
      case 'rejected':
        this.someReviewRejectedModal.show()
        break
    }
  }

  onActualCompleteReviewClick() {
    const { quest, activeReview, currentReviews } = this.props

    // Figure out the next review state so the quest and item in quest list can be updated
    var totalReviewState = getTotalReviewState(currentReviews)
    var friendlyReviewState = translateReviewState(totalReviewState)

    this.props.dispatch(
      completeCompiledQuestReview(
        quest.id,
        quest.reviewing_compiled_quest.id,
        activeReview.id,
        friendlyReviewState
      )
    )

    this.setState({
      isEditing: false
    })

    this.someOeApprovedModal.hide()
    this.readyForPublishModal.hide()
    this.someReviewRejectedModal.hide()
  }

  hideModal() {
    this.cancelReviewModal.hide()
    this.someOeApprovedModal.hide()
    this.readyForPublishModal.hide()
    this.someReviewRejectedModal.hide()
  }

  onRevertToDraftClick() {
    const { dispatch, quest } = this.props
    dispatch(revertQuestToDraft(quest.id))
  }
}

ReviewArea.propTypes = {
  reviewType: PropTypes.string.isRequired,
  quest: PropTypes.object,
  dispatch: PropTypes.func,
  currentReviews: PropTypes.array,
  previousReviews: PropTypes.array,
  activeReview: PropTypes.object,
  user: PropTypes.object,
  isFetchingCurrentCompiledQuest: PropTypes.bool,
  intlReviewType: PropTypes.string,
  organization: PropTypes.object
}

ReviewArea.contextTypes = {
  intl: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  quest: state.quest.item,
  user: state.user.user,
  currentReviews: currentReviewsFilteredForQuestState(state),
  previousReviews: state.quest.previousReviews,
  activeReview: state.quest.activeReview,
  isFetchingCurrentCompiledQuest: state.quest.isFetchingCurrentCompiledQuest,
  organization: state.organization
})

export default connect(mapStateToProps)(ReviewArea)
export { ReviewArea as ReviewAreaDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/review/qualityreview/ReviewArea.js